function getCookieValue(cookieString, variableName) {
  const cookiePairs = cookieString.split(';')

  for (let i = 0; i < cookiePairs.length; i++) {
    const pair = cookiePairs[i].trim()
    if (pair.startsWith(variableName + '=')) {
      const value = pair.substring(variableName.length + 1)
      return decodeURIComponent(value)
    }
  }

  return undefined
}

var language

export function getLocaleLanguage() {
  if (!language) {
    language = getCookieValue(document.cookie, 'miipLang') || 'ko'
  }
  return language
}
